module.exports = __webpack_public_path__ + "static/img/2830_phase_function_Paper_PointsHejduk_Prediction.727869e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2830_phase_function_Paper_PointsHejduk_Prediction.png
// module id = M1S2
// module chunks = 0